export enum InvoiceDocumentTypeEnum {
  INVOICE = "INVOICE",
  CREDIT_NOTE = "CREDIT_NOTE",
}

export function getInvoiceDocumentTypeLabel(type: InvoiceDocumentTypeEnum): string {
  switch (type) {
    case InvoiceDocumentTypeEnum.INVOICE:
      return "Factura";
    case InvoiceDocumentTypeEnum.CREDIT_NOTE:
      return "Abono";
  }
}

export const getInvoiceDocumentTypeOptions = (): { label: string; value: string }[] =>
  Object.keys(InvoiceDocumentTypeEnum).map((key) => {
    const value = InvoiceDocumentTypeEnum[key as keyof typeof InvoiceDocumentTypeEnum];
    return { label: getInvoiceDocumentTypeLabel(value), value, translate: true };
  });
